var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap--sub"
  }, [_c('sub-visual', {
    attrs: {
      "visual": '매칭상담회'
    }
  }), _c('div', {
    staticClass: "contents"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "ct"
  }, [_c('div', {
    staticClass: "tab-menu"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l(_vm.list, function (item) {
    return _c('TabItem', _vm._b({
      key: item.id,
      on: {
        "input": function input($event) {
          _vm.status = _vm.list.find(function (_ref) {
            var id = _ref.id;
            return id == _vm.currentId;
          }).status;
        }
      },
      model: {
        value: _vm.currentId,
        callback: function callback($$v) {
          _vm.currentId = $$v;
        },
        expression: "currentId"
      }
    }, 'TabItem', item, false));
  }), 1)])]), _c('div', {
    staticClass: "tab-contents"
  }, [_c('transition', [_c('section', {
    key: _vm.currentId,
    staticClass: "item"
  }, [_c('fair-list', {
    attrs: {
      "status": _vm.status
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var fairs = _ref2.fairs;
        return _vm._l(fairs, function (fair, index) {
          return _c('fair-list-item', {
            key: fair._id,
            attrs: {
              "fair": fair,
              "to": "/fairs/".concat(fair._id),
              "color": index % 2 ? 'orange' : 'primary'
            },
            on: {
              "apply": _vm.apply
            }
          });
        });
      }
    }])
  })], 1)])], 1)])])]), _c('fair-modal', {
    ref: "fair-modal"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }